// extracted by mini-css-extract-plugin
export var authenticatedHeader = "Layout-module--authenticatedHeader--a4670";
export var container = "Layout-module--container--e5e32";
export var pageContent = "Layout-module--pageContent--74fbe";